import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaUtensils, FaEdit, FaPalette, FaHome } from "react-icons/fa";
import "./Services.css";

const Services = () => {
  const { t } = useTranslation();

  const services = [
    { 
      icon: <FaUtensils />, 
      title: t("services.catering.title"), 
      desc: t("services.catering.desc") 
    },
    { 
      icon: <FaEdit />, 
      title: t("services.customMenus.title"), 
      desc: t("services.customMenus.desc") 
    },
    { 
      icon: <FaPalette />, 
      title: t("services.decorations.title"), 
      desc: t("services.decorations.desc") 
    },
    { 
      icon: <FaHome />, 
      title: t("services.canopySetup.title"), 
      desc: t("services.canopySetup.desc") 
    },
  ];

  return (
    <Container className="py-5" data-aos="fade-up">
      <h2 className="section-title text-center mb-5">
        {t("services.sectionTitle")}
        <div className="underline"></div>
      </h2>
      <Row className="text-center justify-content-center">
        {services.map((service, idx) => (
          <Col
            key={idx}
            xs={6}
            md={3}
            className="service-item"
            data-aos="fade-up"
            data-aos-delay={idx * 100} // 0ms, 100ms, 200ms, 300ms
          >
            <div className="service-content">
              <div className="service-icon">{service.icon}</div>
              <h5 className="mt-3">{service.title}</h5>
              <p className="service-desc">{service.desc}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Services;